import { Box, Card, CardContent, CardHeader, Collapse, makeStyles, Typography } from '@material-ui/core'
import { ExpandLessOutlined, ExpandMoreOutlined } from '@material-ui/icons'
import { KeyboardTimePicker } from '@material-ui/pickers'
import clsx from 'clsx'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { TIME_ZONE_ABBREVIATIONS } from '../../../utils'
import { SubTitle, Title } from '../Common/Headers'

const useStyles = makeStyles((theme) => ({
	row: {},
	header: {
		width: '100%',
		paddingRight: 24,
		paddingLeft: 0,
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		cursor: 'pointer'
		// '& div': {
		// 	fontSize: '21px',
		// 	lineHeight: '30px',
		// 	fontWeight: '600',
		// 	fontFamily: 'Nunito',
		// 	marginRight: 19
		// }
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: '1fr 1fr 1fr',
		marginBottom: '50px'
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: '1fr 1fr'
		// '& .field-wrapper': {
		// 	'& .MuiTextField-root': {
		// 		width: '48%'
		// 	}
		// }
	},
	fieldWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		'& .MuiTextField-root': { width: '49%', minWidth: '49%' }
	},
	checkBox: {
		display: 'flex',
		flexDirection: 'row'
	},
	input: {
		display: 'none'
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	}
}))

const TimeBlocks = (props) => {
	const classes = useStyles()
	let { selectedFacility, setCurrent } = props

	const markets = useSelector((state) => state.specific.markets.markets)

	const [isExpanded, setIsExpanded] = useState(false)
	const [timeZone, setTimeZone] = useState('')

	useEffect(() => {
		if (markets && markets.length && selectedFacility) {
			let market = markets.find((m) => m._id === selectedFacility.market_id)
			if (market?.time_zone) {
				let tz = TIME_ZONE_ABBREVIATIONS[market.time_zone]
				if (tz) setTimeZone(tz)
			}
		}
	}, [selectedFacility, markets])

	return (
		<Card style={{ maxWidth: '1245px' }}>
			<div className={classes.header} onClick={() => setIsExpanded(!isExpanded)}>
				<CardHeader title="Time Blocks" />
				<div style={{ cursor: 'pointer', display: 'flex' }}>
					{isExpanded ? (
						<ExpandLessOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					) : (
						<ExpandMoreOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					)}
				</div>
			</div>
			<Collapse
				in={isExpanded}
				timeout="auto"
				unmountOnExit
				style={{ background: 'transparent', cursor: 'default' }}>
				<CardContent>
					<TimeBlockRow
						title="Morning"
						selectedFacility={selectedFacility}
						setCurrent={setCurrent}
						timeZone={timeZone}
					/>
					<TimeBlockRow
						title="Midday"
						selectedFacility={selectedFacility}
						setCurrent={setCurrent}
						timeZone={timeZone}
					/>
					<TimeBlockRow
						title="Evening"
						selectedFacility={selectedFacility}
						setCurrent={setCurrent}
						timeZone={timeZone}
					/>
					<TimeBlockRow
						title="Night"
						selectedFacility={selectedFacility}
						setCurrent={setCurrent}
						timeZone={timeZone}
					/>
				</CardContent>
			</Collapse>
		</Card>
	)
}

const TimeBlockRow = ({ selectedFacility, setCurrent, title = '', timeZone }) => {
	const classes = useStyles()

	const attribute = title.toLowerCase()

	const tb = selectedFacility?.time_blocks || {}
	let a = (tb && tb[attribute]?.weekdays?.start) || new Date()
	let b = (tb && tb[attribute]?.weekdays?.end) || new Date()
	let c = (tb && tb[attribute]?.weekends?.start) || new Date()
	let d = (tb && tb[attribute]?.weekends?.end) || new Date()

	a = moment(a, 'HH:mm')
	b = moment(b, 'HH:mm')
	c = moment(c, 'HH:mm')
	d = moment(d, 'HH:mm')

	return (
		<Box className={classes.row}>
			<Title label={title} fontSize={16} pt={0} pb="15px" textTransform="capitalize" />
			<Box className={classes.gridDouble}>
				<Box>
					<SubTitle label="Weekdays" fontSize={12} pt={0} pb={0} textTransform="uppercase" />
					<Box className={clsx([classes.fieldWrapper])}>
						<KeyboardTimePicker
							disableFuture
							label="Start Time"
							mask="__:__"
							inputVariant="filled"
							ampm={false}
							value={a}
							InputAdornmentProps={{
								position: 'end',
								component: () => <Typography>{timeZone}</Typography>
							}}
							onChange={(date) => {
								if (date) {
									setCurrent({
										...selectedFacility,
										time_blocks: {
											...tb,
											[attribute]: {
												...tb[attribute],
												weekdays: {
													...tb[attribute]?.weekdays,
													start: moment(date).format('HH:mm')
												}
											}
										}
									})
								}
							}}
						/>
						<KeyboardTimePicker
							disableFuture
							label="End Time"
							mask="__:__"
							inputVariant="filled"
							ampm={false}
							value={b}
							InputAdornmentProps={{
								position: 'end',
								component: () => <Typography>{timeZone}</Typography>
							}}
							onChange={(date) => {
								if (date) {
									setCurrent({
										...selectedFacility,
										time_blocks: {
											...tb,
											[attribute]: {
												...tb[attribute],
												weekdays: {
													...tb[attribute]?.weekdays,
													end: moment(date).format('HH:mm')
												}
											}
										}
									})
								}
							}}
						/>
					</Box>
				</Box>
				<Box>
					<SubTitle label="Weekends" fontSize={12} pt={0} pb={0} textTransform="uppercase" />
					<Box className={clsx([classes.fieldWrapper])}>
						<KeyboardTimePicker
							disableFuture
							label="Start Time"
							mask="__:__"
							inputVariant="filled"
							ampm={false}
							value={c}
							InputAdornmentProps={{
								position: 'end',
								component: () => <Typography>{timeZone}</Typography>
							}}
							onChange={(date) => {
								if (date) {
									setCurrent({
										...selectedFacility,
										time_blocks: {
											...tb,
											[attribute]: {
												...tb[attribute],
												weekends: {
													...tb[attribute]?.weekends,
													start: moment(date).format('HH:mm')
												}
											}
										}
									})
								}
							}}
						/>
						<KeyboardTimePicker
							disableFuture
							label="End Time"
							mask="__:__"
							inputVariant="filled"
							ampm={false}
							value={d}
							InputAdornmentProps={{
								position: 'end',
								component: () => <Typography>{timeZone}</Typography>
							}}
							onChange={(date) => {
								if (date) {
									setCurrent({
										...selectedFacility,
										time_blocks: {
											...tb,
											[attribute]: {
												...tb[attribute],
												weekends: {
													...tb[attribute]?.weekends,
													end: moment(date).format('HH:mm')
												}
											}
										}
									})
								}
							}}
						/>
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

export default TimeBlocks
